import firebase from "firebase/app";
import { FriendRef } from "@dokogd/shared";
export interface CurrentUser extends FriendRef {
  email: string;
}

export type UnlistenerFunction = () => void;
export interface FirebaseCollectionObserver {
  next: (snapshot: firebase.firestore.QuerySnapshot) => void;
  error: (error: Error) => void;
  complete: () => void;
}
export interface FirebaseDocumentObserver {
  next: (snapshot: firebase.firestore.DocumentSnapshot) => void;
  error: (error: Error) => void;
  complete: () => void;
}

export class FriendsState {
  friends: FriendRef[] = [];
  unlistener: null | UnlistenerFunction = null;
}
